import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { connect as connectFormik, Field } from 'formik';
import { ENTITY_STATE } from '../monitoringConstants';
import { domainActions } from '../../../store/domainStore';
import LinkButton, { BUTTON_TYPE } from '../../common/linkButton';
import FixedRightTableTools from "../../layoutItems/fixedRightTableTools";
import FixedRightTable from "../../layoutItems/fixedRightTable";
import ResponsiveTable from "../../layoutItems/responsiveTable";
import { validateInput } from '../../../store/storeFunctions';
import PlusIcon from '../../../img/icons/Plus';

import './createSection.scss'

const COL_WIDTH = 200;
const ROW_HEIGHT = 40;

class PortfolioNotificationReceivers extends React.Component {
    state = {
        receivers: {},
        ownerEmail: ""
    };

    render() {
        return (
            <>
                <div style={this.props.disabled ? { pointerEvents: 'none' } : { pointerEvents: 'auto' }}>
                    <table className="sharing-table table table-report-section">
                        <thead>
                            <tr>
                                <th><Translate id="Monitoring.Create.Receivers" /></th>
                                <th colSpan={2} width="10%" className='align-right'>
                                    <Translate id="Common.Actions" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(this.state.receivers).map(k => this.renderRow(this.state.receivers[k]))}
                            {this.props.sharingRole === 0 &&
                                <tr className="monitoring-receiver-row monitoring-add-receiver">
                                    <td colSpan={3}>
                                        <div className={classnames("ml-link", "color")} >
                                            <span title={this.props.translate("Monitoring.Create.AddReceiver")}>
                                                <PlusIcon className="ml-link-icon" style={{ verticalAlign: "middle" }}
                                                    onClick={() => { this.addRecieverRow() }}
                                                />
                                            </span>
                                        </div>
                                    </td>
                                </tr>}
                        </tbody>
                    </table>
                </div>
                {/*<div className="hide-on-desktop">
                    <div style={{ marginBottom: "1.5em" }}>
                        <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            onClick={() => this.addRecieverRow()}
                        >
                            <Translate id="Monitoring.Create.AddReceiver" />
                        </button>
                    </div>
                    <div style={{ marginBottom: "2.5em" }}>
                        <FixedRightTable center
                            leftData={this.leftData()}
                            rightData={this.rightData()}
                            leftHeader={[[<div className="bold"><Translate id="Monitoring.Create.Receivers" /></div>]]}
                            rightHeader={[[<div />]]}
                            additionalHeight={() => 0}
                            rowHeight={ROW_HEIGHT}
                            maxWidth={2 * COL_WIDTH + 125}
                            leftColumnWidth={this.leftColumnWidth}
                            rightColumnWidth={125}
                        />
                    </div>
        </div>*/}
            </>
        );
    }

    componentDidMount() {
        const data = {};
        this.props.formik.values.monitoringSettings.notificationReceivers.forEach((r, i) => data[String(i)] = {
            value: r,
            index: i,
            state: ENTITY_STATE.loaded
        });
        this.setState({ receivers: data, ownerEmail: this.props.formik.values.monitoringSettings.ownerEmail });
    }

    renderRow = (recv, mobile = false) => {
        if (mobile) {
            return (
                <div className="monitoring-cell-mobile">
                    {recv.state === ENTITY_STATE.edited || recv.state === ENTITY_STATE.inserted
                        ? <Field type="text" className="input" value={recv.value} onChange={e => this.onValueChanged(recv.index, e.target.value)} onInput={(e) => validateInput(e)} />
                        : recv.value
                    }
                </div>
            );
        }

        return (
            <tr className="monitoring-receiver-row" key={recv.index}>
                <td style={{ fontWeight: "normal" }}>
                    {recv.state === ENTITY_STATE.edited || recv.state === ENTITY_STATE.inserted
                        ? <Field type="text" className="input" value={recv.value} onChange={e => this.onValueChanged(recv.index, e.target.value)}  onInput={(e) => validateInput(e)}/>
                        : recv.value
                    }
                </td>
                {this.props.sharingRole === 0 && this.state.ownerEmail != recv.value?
                    <>
                        <td>{recv.state === ENTITY_STATE.edited || recv.state === ENTITY_STATE.inserted
                            ? <LinkButton type={BUTTON_TYPE.save} onClick={() => this.applyValue(recv.index)} />
                            : <LinkButton type={BUTTON_TYPE.edit} onClick={() => this.editValue(recv.index)} />}
                        </td>
                        <td><LinkButton type={BUTTON_TYPE.remove} onClick={() => this.removeValue(recv.index)} /></td>
                    </>
                    : <td colSpan="2" />
                }
            </tr>
        )
    }

    leftData = () => Object.keys(this.state.receivers).map(k => [this.renderRow(this.state.receivers[k], true)]);

    rightData = () => Object.keys(this.state.receivers).map(k => [<div className="monitoring-cell-mobile" style={{ paddingLeft: "5px" }}>
        {this.generateContextMenu(this.state.receivers[k])}
    </div>])

    generateContextMenu = (recv) => {
        const buttons = [];
        if (this.props.sharingRole === 0) {
            if (recv.state === ENTITY_STATE.loaded)
                buttons.push({ item: <LinkButton type={BUTTON_TYPE.edit} />, action: () => this.editValue(recv.index) });
            else
                buttons.push({ item: <LinkButton type={BUTTON_TYPE.apply} />, action: () => this.applyValue(recv.index) });
            buttons.push({ item: <LinkButton type={BUTTON_TYPE.remove} />, action: () => this.removeValue(recv.index) });
        }

        return (
            <FixedRightTableTools
                mode="none"
                style={{ float: "none" }}
                id={`monitoring-receiver-${recv.index}`}
                buttonClassName="monitoring-context-btn"
                content={<LinkButton type={BUTTON_TYPE.tools} />}
                contentWidth={250}
                buttons={buttons}
                menuStyle={{ position: "absolute", left: "-105px", width: "15em" }}
                buttonStyle={{ width: "100%", textAlign: "left" }}
            />
        );
    }

    leftColumnWidth = (col) => {
        switch (col) {
            case 0: return 2 * COL_WIDTH;
            default: return COL_WIDTH;
        }
    }

    addRecieverRow = () => {
        const newIndex = this.props.formik.values.monitoringSettings.notificationReceivers.length;
        this.setState({ receivers: { ...this.state.receivers, [String(newIndex)]: { value: "", index: newIndex, state: ENTITY_STATE.inserted } } });
        this.props.formik.setFieldValue('monitoringSettings.notificationReceivers', this.props.formik.values.monitoringSettings.notificationReceivers.concat(['']));
    }

    onValueChanged = (index, value) => this.updateProperty(index, "value", value);
    editValue = (index) => this.updateProperty(index, "state", ENTITY_STATE.edited);

    applyValue = (index) => {
        const value = this.state.receivers[String(index)].value;
        if (value.length === 0) {
            this.props.addErrorMessage([]);
            return;
        } else if (!this.props.validateEmail(value)) {
            this.props.addErrorMessage({ value })
        } else {
            this.props.addErrorMessage([]);
            this.props.formik.setFieldValue(`monitoringSettings.notificationReceivers[${index}]`, value);
            this.updateProperty(index, "state", ENTITY_STATE.loaded);
        }
    }

    removeValue = (index) => {
        this.props.formik.setFieldValue(
            'monitoringSettings.notificationReceivers',
            this.props.formik.values.monitoringSettings.notificationReceivers.filter((_, i) => i !== index)
        );
        this.setState({ receivers: Object.assign({}, ...Object.keys(this.state.receivers).filter(key => key !== String(index)).map(k => ({ [k]: this.state.receivers[k] }))) });
    }

    updateProperty = (index, prop, value) => {
        this.setState({ receivers: { ...this.state.receivers, [String(index)]: { ...this.state.receivers[String(index)], [prop]: value } } });
    }
}

export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(PortfolioNotificationReceivers)));